import { Table, TableWrapper, Tbody, Td, Th, Thead, Tr } from '@components/core-ui/Table';
import { Header } from '@components/Header';
import Done from '@components/icons/Done.svg';
import { LinearProgressLoader } from '@components/core-ui/spinners/LinearProgressLoader';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { useModalContext } from '@providers/ModalProvider';
import { useAPI } from '@providers/useAPI';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { CourseStudentResponseDto } from 'app/API';
import { canvasKeys } from 'app/queries/canvas/canvasKeys';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useParams } from 'react-router';
import { createFetchCanvasCourseStudentsQueryFn } from '../../api/fetchCanvasCourseStudents';
import { Wrapper } from './styles/Wrapper';

export const Content = () => {
  const { call } = useAPI();
  const queryClient = useQueryClient();
  const { openModal } = useModalContext();
  const params = useParams() as { id?: string };
  const courseId = (params.id || 0).toString();

  const studentsQuery = useQuery({
    queryKey: canvasKeys.courseStudentsByCourse(courseId),
    queryFn: createFetchCanvasCourseStudentsQueryFn(call),
  });
  const students = studentsQuery.data ?? [];
  const isLoading = studentsQuery.isFetching;

  const createStudent = () => {
    openModal(ModalNamesEnum.AddCourseStudent, {
      courseId: params.id,
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: canvasKeys.courseStudentsByCourse(courseId) });
      },
    });
  };

  return (
    <>
      <Header title={'Canvas Course Students List'} buttonLabel={'Add student'} buttonOnClick={() => createStudent()} />
      <Wrapper>
        <LinearProgressLoader active={isLoading} />
        <TableWrapper>
          <Table>
            <Thead>
              <Tr>
                <Th>ID</Th>
                <Th>Name</Th>
                <Th>Created</Th>
                <Th>Login</Th>
                <Th>ASW Registered</Th>
                <Th>Farthest license expires</Th>
              </Tr>
            </Thead>
            <Tbody>
              {(students ?? []).map((data: CourseStudentResponseDto) => (
                <Tr key={data.id}>
                  <Td>
                    <p className="cell">{data?.id}</p>
                  </Td>
                  <Td>
                    <p className="cell">{data?.name}</p>
                  </Td>
                  <Td>
                    <p className="cell">{getAmericanTime(data.created_at)}</p>
                  </Td>
                  <Td>
                    <p className="cell">{data.login_id}</p>
                  </Td>
                  <Td>
                    <p className="cell">{data.registeredInASW ? <Done width="16px" /> : null}</p>
                  </Td>
                  <Td>
                    <p className="cell">
                      {data.farthestExpirationDate ? getAmericanTime(data.farthestExpirationDate) : null}
                    </p>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableWrapper>
      </Wrapper>
    </>
  );
};
